import { SvgIcon } from '@mui/material';
import { memo } from 'react';

const EditIcon = ({ ...props }) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M12.5089 4.73277L15.2533 7.47722M13.6732 3.56839C14.4311 2.81054 15.6598 2.81054 16.4177 3.56839C17.1756 4.32625 17.1756 5.55499 16.4177 6.31284L5.73054 17H3.01367V14.228L13.6732 3.56839Z"
        stroke="currentColor"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default memo(EditIcon);
